module.exports = __webpack_public_path__ + "media/images/img-paolo-dela-fuente-346b6fad23bebdb19db1a1a9b0950b63.jpg";